import TEForm from './TEForm';

export default TEForm;
